import { render } from "./NavbarPrimary.vue?vue&type=template&id=6a8e1880&ts=true"
import script from "./NavbarPrimary.vue?vue&type=script&lang=ts"
export * from "./NavbarPrimary.vue?vue&type=script&lang=ts"

import "./NavbarPrimary.vue?vue&type=style&index=0&id=6a8e1880&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/header/NavbarPrimary.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6a8e1880"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6a8e1880', __exports__)) {
    api.reload('6a8e1880', __exports__)
  }
  
  module.hot.accept("./NavbarPrimary.vue?vue&type=template&id=6a8e1880&ts=true", () => {
    api.rerender('6a8e1880', render)
  })

}


export default __exports__